import { fetchApi } from '@/config/axiosSetting';
import { IBodyPatchVisitInformationParams } from '@/modules/adjusterReportModules/Insurer-information/queries/patchBodyVisitInformation/patchBodyVisitInformationQuery.type';

export const patchBodyVisitInformationQueryFunction = (
  params: IBodyPatchVisitInformationParams,
) => {
  return fetchApi.patch(
    `body/reports/${params?.id}/adjusting/visit_information/`,
    {
      ...params?.data,
    },
    {
      params: {
        id: params?.id,
        source: 'pwa',
      },
    },
  );
};
